<ng-container *ngIf="back">
  <a [routerLink]="back.url" [queryParams]="back.queryParams" [fragment]="back.fragment" class="govuk-back-link">Back</a>
</ng-container>
